
import { mapState } from 'vuex';

export default {
    name: 'UserRegisterForm',
    props: {
        /**
         * A form object
         */
        form: {
            type: Object,
            required: true,
        },
        /**
         * Should we hide the password field?
         */
        hidePassword: {
            type: Boolean,
            default: false,
        },
        /**
         * Show mobile number field?
         */
        showMobileNumber: {
            type: Boolean,
            default: false,
        },
        /**
         * Show text notifications checkbox?
         */
        showTextNotifications: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState(['isCordova']),
        termsLabel() {
            return this.$t('auth.accept_terms').split(new RegExp(/<a>([\w\s]+)<\/a>/));
        },
    },
};
